import { PhysicalMeterResponse } from './PhysicalMeterResponse';
import { SiteResponse } from './SiteResponse';

export interface HeadPointResponse {
  ean: string;
  sites?: SiteResponse[];
  physicalMeters?: PhysicalMeterResponse[];
}

const HeadPointGetSite = (headpoint?: HeadPointResponse) => {
  return headpoint?.sites?.length === 0 ? null : headpoint?.sites?.[0];
};

export const HeadPointGetAddress = (language: string, headpoint?: HeadPointResponse): string => {
  const site = HeadPointGetSite(headpoint);
  return language === 'nl'
    ? `${site?.streetNl ?? ''} ${
        site?.houseNumber == null ? '' : `${site?.houseNumber},`
      }${site?.houseNumberExt == null ? '' : ` ${site?.houseNumberExt},`} ${
        site?.postCode ?? ''
      } ${site?.cityNl ?? ''}`
    : `${site?.streetFr ?? ''} ${
        site?.houseNumber == null ? '' : `${site?.houseNumber},`
      }${site?.houseNumberExt == null ? '' : ` ${site?.houseNumberExt},`} ${
        site?.postCode ?? ''
      } ${site?.cityFr ?? ''}`;
};
